import { Center, Spinner, Text } from "@chakra-ui/react";

interface PageLoaderProps {
  /** What is being waited for, shown and announced (ux-principles: loading states say what happens). */
  label: string;
}

/**
 * A region-level loading state: a spinner in brand tokens with a visible,
 * announced label. The spinner stops under `prefers-reduced-motion: reduce`;
 * the label still says what is happening.
 */
const PageLoader = ({ label }: PageLoaderProps) => (
  <Center
    minH="40vh"
    flexDirection="column"
    gap={3}
    role="status"
    aria-live="polite"
    data-testid="page-loader"
  >
    <Spinner
      size="xl"
      thickness="4px"
      speed="0.65s"
      color="brand.solid"
      emptyColor="border.subtle"
      aria-hidden="true"
      sx={{ "@media (prefers-reduced-motion: reduce)": { animation: "none" } }}
    />
    <Text color="text.secondary">{label}</Text>
  </Center>
);

export default PageLoader;
